/**
 * Точки перелома раскладки (D52).
 *
 * Те же два числа, что в `brand.css` (`--rc-bp-wide`, `--rc-bp-ultra`)
 * и в медиазапросах `app.css`. Три места, а не одно, по причине,
 * которая от нас не зависит: медиазапрос не умеет читать
 * пользовательское свойство, а код не умеет читать медиазапрос.
 *
 * Расхождение ловит `layout.test.ts`: он читает оба файла и сверяет
 * значения. Это тот случай, когда правило проверяется в CI, а не
 * на ревью (CLAUDE.md, п. 5) — дублирование неизбежно, значит
 * неизбежна и проверка.
 */

/** С этой ширины содержимое встаёт в две колонки. */
export const WIDE = 900

/** С этой — появляется третья колонка. */
export const ULTRA = 1400

/** Медиазапрос по точке перелома: `matchMedia` берёт его как есть. */
export function atLeast(width: number): string {
  return `(min-width: ${String(width)}px)`
}
